<template>
    <div v-if="info" class="ai-usage-info" dir="rtl">
        <div class="ai-usage-info__stats">
            <div class="ai-usage-info__row">
                <span class="ai-usage-info__label">المتبقي مجاناً اليوم:</span>
                <strong>{{ freeRemaining }} / {{ freeLimit }}</strong>
            </div>
            <div v-if="chargedFromCredits" class="ai-usage-info__row">
                <span class="ai-usage-info__label">تكلفة هذا الطلب:</span>
                <strong class="ai-usage-info__cost">{{ formattedCost }} د.أ</strong>
            </div>
            <div class="ai-usage-info__row">
                <span class="ai-usage-info__label">رصيدك:</span>
                <strong class="ai-usage-info__balance">{{ formattedBalance }} د.أ</strong>
            </div>
        </div>
        <a
            :href="topUpUrl"
            target="_blank"
            class="ai-usage-info__topup-btn"
            :aria-label="tooltipText"
        >
            <svg class="ai-usage-info__bolt" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z"/>
            </svg>
            <span>اشحن رصيد ذكاء صناعي الآن</span>
            <q-tooltip
                anchor="top middle"
                self="bottom middle"
                :offset="[0, 8]"
                class="ai-usage-info__tooltip"
                max-width="320px"
                transition-show="scale"
                transition-hide="scale"
            >
                {{ tooltipText }}
            </q-tooltip>
        </a>
    </div>
</template>

<script>
export default {
    name: 'AiUsageInfo',
    props: {
        info: {
            type: Object,
            default: null,
        },
    },
    computed: {
        freeUsed() {
            return this.info && this.info.free_used !== undefined ? this.info.free_used : 0
        },
        freeLimit() {
            return this.info && this.info.free_limit !== undefined ? this.info.free_limit : 0
        },
        freeRemaining() {
            return this.info && this.info.free_remaining !== undefined ? this.info.free_remaining : 0
        },
        chargedFromCredits() {
            return !!(this.info && this.info.charged_from_credits)
        },
        formattedCost() {
            const v = this.info && this.info.last_request_cost_jod !== undefined ? this.info.last_request_cost_jod : 0
            return parseFloat(v || 0).toFixed(4)
        },
        formattedBalance() {
            const v = this.info && this.info.balance_jod !== undefined ? this.info.balance_jod : 0
            return parseFloat(v || 0).toFixed(3)
        },
        topUpUrl() {
            return this.info && this.info.top_up_url ? this.info.top_up_url : '/checkout?type=ai-credit'
        },
        tooltipText() {
            return 'اشحن رصيدك المدفوع لمواصلة استخدام مساعد الذكاء الاصطناعي بعد انتهاء الحصة المجانية اليومية. الرصيد مشترك بين كل الميزات: المحادثة، الملخصات، البطاقات التعليمية، ودردشة المكتبة.'
        },
    },
}
</script>

<style scoped>
.ai-usage-info {
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px 14px;
    margin-top: 14px;
    margin-bottom: 14px;
    font-size: 12px;
    color: #475569;
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.ai-usage-info__stats {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    align-items: center;
}
.ai-usage-info__row {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}
.ai-usage-info__label {
    color: #64748b;
}
.ai-usage-info__cost {
    color: #b45309;
}
.ai-usage-info__balance {
    color: #1d4ed8;
}

/* Top-up call-to-action button */
.ai-usage-info__topup-btn {
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 14px;
    border-radius: 10px;
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    color: #ffffff !important;
    font-weight: 700;
    font-size: 13px;
    text-decoration: none;
    box-shadow: 0 2px 6px rgba(245, 158, 11, 0.25);
    transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
    cursor: pointer;
    border: none;
    line-height: 1.2;
}
.ai-usage-info__topup-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.35);
    background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
    color: #ffffff !important;
    text-decoration: none;
}
.ai-usage-info__topup-btn:active {
    transform: translateY(0);
}
.ai-usage-info__bolt {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
}

/* Quasar tooltip override (NOT scoped — q-tooltip renders in body) */
</style>

<style>
.ai-usage-info__tooltip {
    direction: rtl;
    text-align: right;
    font-size: 13px;
    line-height: 1.6;
    padding: 10px 14px;
    background: #1f2937;
    color: #f9fafb;
    border-radius: 8px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
}

@media (min-width: 480px) {
    .ai-usage-info {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
    .ai-usage-info__topup-btn {
        align-self: auto;
        white-space: nowrap;
    }
}
</style>
